<mat-accordion *ngIf="formTermHasBeenLoaded">
    <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Open for Grading
            </mat-panel-title>
            <mat-panel-description>Please click on the term to edit.</mat-panel-description>
        </mat-expansion-panel-header>
        <app-sortable-table *ngIf="gradingSchedule?.length > 0 "
                            [data]="gradingSchedule">

            <thead>
            <tr>
                <th sortBy="termCode">Term</th>
                <th sortBy="termStartDate">Term Open</th>
                <th sortBy="openDate">Grading Start</th>
                <th sortBy="numberTimeAllowedGradeChange">Grade Change Limit</th>
                <th sortBy="lastUpdated">Last Modified On</th>
                <th >Term Grading Open</th>
                <th sortBy="updatedByName">Last Modified By</th>
            </tr>
            </thead>
            <tbody>

            <tr *ngFor="let schedule of gradingSchedule">
                <td><a (click)="editGradingSchedule(schedule)">{{schedule.termDescription}}</a></td>
                <td>{{schedule.termStartDate | date:'MM/dd/yyyy'}}</td>
                <td>{{schedule.openDate| date:'MM/dd/yyyy hh:mm a'}}</td>
                <td>{{schedule.numberTimeAllowedGradeChange}}</td>
                <td>{{schedule.lastUpdated| date:'MM/dd/yyyy hh:mm a'}}</td>
                <td>{{schedule.enabled ? 'Yes': 'No'}}</td>
                <td>{{schedule.updatedByName}}</td>

            </tr>
            </tbody>
        </app-sortable-table>
    </mat-expansion-panel>
    <mat-expansion-panel [expanded]="false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Closed For Grading
            </mat-panel-title>
            <mat-panel-description>Please click on the term to edit.</mat-panel-description>
        </mat-expansion-panel-header>
        <app-sortable-table *ngIf="pastGradingSchedule?.length > 0 "
                            [data]="pastGradingSchedule">

            <thead>
            <tr>
                <th sortBy="termCode">Term</th>
                <th sortBy="termStartDate">Term Open</th>
                <th sortBy="openDate">Grading Start</th>
                <th sortBy="numberTimeAllowedGradeChange">Grade Change Limit</th>
                <th sortBy="lastUpdated">Last Modified On</th>
                <th >Term Grading Open</th>
                <th sortBy="updatedByName">Last Modified By</th>
            </tr>
            </thead>
            <tbody>

            <tr *ngFor="let schedule of pastGradingSchedule">
                <td><a (click)="editGradingSchedule(schedule)">{{schedule.termDescription}}</a></td>
                <td>{{schedule.termStartDate | date:'MM/dd/yyyy'}}</td>
                <td>{{schedule.openDate| date:'MM/dd/yyyy hh:mm a'}}</td>
                <td>{{schedule.numberTimeAllowedGradeChange}}</td>
                <td>{{schedule.lastUpdated| date:'MM/dd/yyyy hh:mm a'}}</td>
                <td>{{schedule.enabled ? 'Yes': 'No'}}</td>
                <td>{{schedule.updatedByName}}</td>

            </tr>
            </tbody>
        </app-sortable-table>
    </mat-expansion-panel>
</mat-accordion>